"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const badge_value_1 = __importDefault(require("./badge-value"));
const base_1 = __importDefault(require("./base"));
const defaults_1 = require("./defaults");
const image_object_1 = __importDefault(require("./image-object"));
class Badge extends base_1.default {
    constructor(data = {
        title: undefined,
        description: undefined,
        icon: undefined,
        type: undefined,
        value: undefined,
        level_color: '255, 255, 255',
    }) {
        super(data);
        this.title = (0, defaults_1.defaultString)(data.title);
        this.description = (0, defaults_1.defaultString)(data.description);
        this.icon = new image_object_1.default((0, defaults_1.defaultObject)(data.icon));
        this.type = (0, defaults_1.defaultString)(data.type);
        this.value = new badge_value_1.default((0, defaults_1.defaultObject)(data.value));
        this.level_color = (0, defaults_1.defaultString)(data.level_color);
    }
    get levelColor() {
        return this.level_color;
    }
}
exports.default = Badge;
